import React, { useEffect, useState } from 'react';
import '../Estilos/TextInput.css';
import '../Estilos/Fontes.css';
import '../Estilos/Componentes.css';
import Checkbox from '@mui/material/Checkbox';

export default function CheckBoxOpcoes({ titulo, items = [], clicado, width, top, left, altura, multiple = true, disabled = false}) {
  const [selectedItems, setSelectedItems] = useState([]);

  useEffect(() => {
    // Initialize selectedItems state with a defined state property for each item
    setSelectedItems(items.map(item => ({ ...item, state: item.state ?? false })));
  }, [items]);

  const handleCheckboxChange = (value) => {
    if (disabled) return;
    const updatedItems = selectedItems.map((item) => {
      if (!multiple) {
        return { ...item, state: item.value === value };
      }
      if (item.value === value) {
        return { ...item, state: !item.state };
      }
      return item;
    });
    setSelectedItems(updatedItems);
    clicado(value);
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        width: width || '100%',
        marginTop: top || 0,
        marginLeft: left || 0,
      }}
    >
      <h3 id="TituloInput">{titulo}</h3>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          height: altura || 500,
          flexWrap: 'wrap',
          overflowX: 'auto',
          overflowY: 'hidden',
        }}
      >
        {selectedItems.map((item) => (
          <div
            key={item.value}
            style={{
              display: 'flex',
              alignItems: 'center',
              cursor: 'pointer',
              marginTop: 0,
              height: 30,
              disabled: disabled,
            }}
            onClickCapture={() => handleCheckboxChange(item.value)}
          >
            <Checkbox color="success" id={item.nome} checked={!!item.state} disabled={disabled} />
            <label
              style={{
                fontSize: 14,
                fontFamily: 'montserrat',
                color: '#2f2f2f',
                cursor: 'pointer',
              }}
              htmlFor={item.nome}
            >
              {item.nome}
            </label>
          </div>
        ))}
      </div>
    </div>
  );
}
